import mrpStyles from './../mrp.json'

export default {
  name: 'B4',
  color: mrpStyles.colors.SecondaryGreyMetal,
  fontStyle: 'italic'
}
